
export const productSelectionAction = (data: any) => {
    return {
        type: 'PRODUCT_SELECTION',
        payload: data
    };
}

export const productGroupSelectionAction = (data: any) => {
    return {
        type: 'GROUP_SELECTION',
        payload: data
    };
}